import { render, staticRenderFns } from "./addBuildinguserGmap.vue?vue&type=template&id=851e9c9e&"
import script from "./addBuildinguserGmap.vue?vue&type=script&lang=js&"
export * from "./addBuildinguserGmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports